
export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4 bg-gradient-to-r from-pink-400 to-blue-400 bg-clip-text text-transparent">
              Dr. Germán Delgadillo Espejo
            </h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              Ginecólogo especializado en salud femenina, embarazo, planificación familiar y ultrasonido ginecológico en Guadalajara.
            </p>
            {/* Cédulas profesionales */}
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2">
                <i className="ri-file-text-line text-yellow-400"></i>
                <span className="text-gray-300">Cédula Profesional: <span className="text-yellow-400 font-medium">5131559</span></span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-medal-line text-yellow-400"></i>
                <span className="text-gray-300">Cédula de Especialidad: <span className="text-yellow-400 font-medium">8192590</span></span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Servicios</h4>
            <ul className="space-y-2 text-gray-300">
              <li className="hover:text-pink-400 transition-colors cursor-pointer">Consulta ginecológica</li>
              <li className="hover:text-pink-400 transition-colors cursor-pointer">Control prenatal</li>
              <li className="hover:text-pink-400 transition-colors cursor-pointer">Papanicolaou y colposcopia</li>
              <li className="hover:text-pink-400 transition-colors cursor-pointer">Ultrasonido ginecológico</li>
              <li className="hover:text-pink-400 transition-colors cursor-pointer">Planificación familiar</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-pink-400"></i>
                <a href="tel:+523319882655" className="hover:text-pink-400 transition-colors cursor-pointer">
                  +52 33 1988 2655
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-pink-400"></i>
                <a href="mailto:contacto@drdelgadillo.com" className="hover:text-pink-400 transition-colors cursor-pointer">
                  contacto@drdelgadillo.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-pink-400 mt-1"></i>
                <span>Dirección: Av. Belisario Domínguez 288, Oblatos, 44380 Guadalajara, Jal.</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              Dr. Germán Delgadillo Espejo – Ginecólogo en Guadalajara. Atención profesional en salud femenina, embarazo, planificación familiar y ultrasonido ginecológico.
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="https://citadoctor.com.mx" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-pink-400 transition-colors text-sm cursor-pointer whitespace-nowrap"
              >
                Hecho por CitaDoctor
              </a>
            </div>
          </div>
          <p className="text-gray-500 text-sm text-center mt-4">
            © {new Date().getFullYear()} Dr. Germán Delgadillo Espejo. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
